import React, { useState } from "react";

type Token = {
    id: string;
    field: string;
    operator: string;
    value: string;
};

const fields = [
    { key: "assignee", label: "Assignee", values: ["Linh", "Huy", "Nam"] },
    { key: "author", label: "Author", values: ["Linh", "Huy"] },
    { key: "label", label: "Label", values: ["Bug", "Feature", "Hotfix"] },
];

const operators = ["is", "is not", "contains"];

export default function FilteredSearch() {
    const [tokens, setTokens] = useState<Token[]>([]);
    const [step, setStep] = useState<"field" | "operator" | "value" | null>(null);
    const [draft, setDraft] = useState<Partial<Token>>({});

    const startNewToken = () => {
        setStep("field");
        setDraft({});
    };

    const addToken = (draft: Partial<Token>) => {
        if (draft.field && draft.operator && draft.value) {
            setTokens([
                ...tokens,
                {
                    id: Date.now().toString(),
                    field: draft.field,
                    operator: draft.operator,
                    value: draft.value,
                },
            ]);
            setStep(null);
            setDraft({});
        }
    };

    const removeToken = (id: string) => {
        setTokens((prev) => prev.filter((t) => t.id !== id));
    };

    return (
        <div className="w-full max-w-2xl">
            <div className="m-4 flex flex-wrap items-center gap-2 border rounded px-2 py-2 bg-white shadow-sm">
                {tokens.map((t) => (
                    <div
                        key={t.id}
                        className="flex items-center gap-1 px-2 py-1 rounded hover:bg-gray-100 text-sm"
                    >
                        <span className="font-medium">{t.field}</span>
                        <span>{t.operator}</span>
                        <span className="text-blue-600">{t.value}</span>
                        <button
                            onClick={() => removeToken(t.id)}
                            className="ml-1 text-gray-400 hover:text-red-500"
                        >
                            ✕
                        </button>
                    </div>
                ))}

                {/* Input để bắt đầu search */}
                <div
                    className="min-w-[120px] text-gray-500 cursor-text"
                    onClick={startNewToken}
                >
                    {step ? "" : "Search..."}
                </div>
            </div>

            {/* Dropdown Suggest */}
            {step === "field" && (
                <div className="mt-2 border rounded-lg bg-white shadow-lg p-2">
                    <div className="font-semibold text-sm text-gray-600 px-2 mb-1">
                        Choose Field
                    </div>
                    {fields.map((f) => (
                        <div
                            key={f.key}
                            className="px-2 py-1 hover:bg-gray-100 cursor-pointer"
                            onClick={() => {
                                setDraft({ field: f.label });
                                setStep("operator");
                            }}
                        >
                            {f.label}
                        </div>
                    ))}
                </div>
            )}

            {step === "operator" && (
                <div className="mt-2 border rounded-lg bg-white shadow-lg p-2">
                    <div className="font-semibold text-sm text-gray-600 px-2 mb-1">
                        Choose Operator
                    </div>
                    {operators.map((op) => (
                        <div
                            key={op}
                            className="px-2 py-1 hover:bg-gray-100 cursor-pointer"
                            onClick={() => {
                                setDraft({ ...draft, operator: op });
                                setStep("value");
                            }}
                        >
                            {op}
                        </div>
                    ))}
                </div>
            )}

            {step === "value" && draft.field && (
                <div className="m-4 mt-2 border rounded bg-white shadow-lg p-2">
                    <div className="font-semibold text-sm text-gray-600 px-2 mb-1">
                        Choose Value
                    </div>
                    {fields
                        .find((f) => f.label === draft.field)
                        ?.values.map((val) => (
                            <div
                                key={val}
                                className="px-2 py-1 hover:bg-gray-100 cursor-pointer"
                                onClick={() => {
                                    setDraft((d) => {
                                        const newDraft = { ...d, value: val };
                                        if (
                                            newDraft.field &&
                                            newDraft.operator &&
                                            newDraft.value
                                        ) {
                                            addToken(newDraft);
                                            return {};
                                        }
                                        return newDraft;
                                    });
                                }}
                            >
                                {val}
                            </div>
                        ))}
                </div>
            )}
        </div>
    );
}
